import { useCallback, useEffect, useState } from "react";
import { GateToDropoffRoute } from "../models/GateToDropoffRoute";
import PlotAPI from "../plotAPI";

interface useGateToDropoffRoutesProps {
    projects: any[];
    projectInfo: (projectId: string | number) => any | null;
}

const useGateToDropoffRoutes = ({ projects, projectInfo }: useGateToDropoffRoutesProps) => {
    const [gateToDropoffRoutesByProject, setGateToDropoffRoutesByProject] = useState<
        { unique_token: string; gateToDropoffRoutes: GateToDropoffRoute[] }[]
    >([]);

    const refreshGateToDropoffRoutesByProject = useCallback(() => {
        return Promise.all(
            projects.map((project) =>
                PlotAPI.getProjectGateToDropoffRoutes(
                    project.claimed_by_team_subdomain || "projects",
                    project.unique_token,
                    project.timezone
                ).then((gateToDropoffRoutes) => {
                    return {
                        unique_token: project.unique_token,
                        gateToDropoffRoutes,
                    };
                })
            )
        ).then((gateToDropoffRoutes) => {
            setGateToDropoffRoutesByProject(gateToDropoffRoutes);
        });
    }, [projects]);

    useEffect(() => {
        refreshGateToDropoffRoutesByProject();
    }, [projects, refreshGateToDropoffRoutesByProject]);

    const gateToDropoffRoutesForProject = (projectId: string | number): GateToDropoffRoute[] => {
        const projectToken = projectInfo(projectId)?.unique_token;

        return (
            gateToDropoffRoutesByProject.find((project) => project.unique_token === projectToken)
                ?.gateToDropoffRoutes || []
        );
    };

    return {
        gateToDropoffRoutesByProject,
        gateToDropoffRoutesForProject,
        refreshGateToDropoffRoutesByProject,
    };
};

export default useGateToDropoffRoutes;
